
(function () {
    'use strict';

    var controllerId = 'mainCtrl';
    angular.module('app').controller(controllerId,
        ['$scope', '$location', 'userService', 'datacontext', '$http', '$cookies', '$modal', mainCtrl]);

    function mainCtrl($scope, $location,  userService, datacontext, $http, $cookies, $modal) {

        $scope.$watch(
            function () {
                return userService.getCurrentUser(); },
                    function (newValue, oldValue) {
                        if( newValue != oldValue || !angular.isDefined($scope.currentUser)) {
                            $scope.currentUser = newValue;
                        }
                        $scope.message_cnt = 0;
                        $scope.server_time = new Date();
                        $scope.user_id = $cookies.get('user_id');
                        console.log("$scope.user_id:"+$scope.user_id);
                        if($scope.user_id !== 'undefined'){
                          datacontext.get_message_cnt($scope.user_id).success(function(httpResult) {
                            $scope.message_cnt = httpResult.TOTAL;
                          });
                        }

                        // console.log($scope.server_time);
                        // $scope.server_time = new Date($scope.server_time.getTime() - ((1 * 60 * 60 * 1000) * 5));
                        // console.log($scope.server_time);
        });

        var host = $location.host();
        var enviroment = host.substring(host, host.indexOf(".", 1));
        var vm = this;
        $scope.user_role_id = 0;
        if( angular.isDefined($cookies.get('user_role_id')) ) {
          $scope.user_role_id = $cookies.get('user_role_id');
        }
        $scope.user_id = 0;
        if( angular.isDefined($cookies.get('user_id')) ) {
          $scope.user_id = $cookies.get('user_id');
        }
        console.log("vm.user_role_id"+$scope.user_role_id);
        switch(enviroment) {
            case 'ace':
                $scope.enviroment = 'prod';
                break;
            case 'deuce':
                $scope.enviroment = 'qa';
                break;
            default:
                $scope.enviroment = 'dev';
        }

        //function get_users() {
        //     return $http.get('/apis/users.cfc?method=get_users&is_secure=0').error(function(data, status, headers, config) {});
        // }
        //
        // $scope.user_list = [];
        //
        // get_users().then(function(httpResult) {
        //     angular.forEach(httpResult.data.data, function(obj) {
        //          // limit data to login and id
        //          var payload = {
        //              user_id: obj.user_id,
        //              user_login: obj.user_login
        //          };
        //          $scope.user_list.push(payload);
        //      });
        // });

        $scope.logout = function () {
            userService.logOut();
        }
        $scope.suggestion_box = function () {
          $scope.user_id = $cookies.get('user_id');
          var modalInstance = $modal.open({
               templateUrl: '/app/homepage/suggestion_box.html',
               controller: 'suggestionBoxctrl',
               windowClass: 'small',
               resolve: {
                 user_id: function () {
                     return $scope.user_id;
                 }
               }
           }).result.then(function (result) {

           });

           vm.cancel = function () {
               modalInstance.dismiss('cancel');
           };
       };
    }
})();
(function () {
    'use strict';
    var controllerId = 'suggestionBoxctrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'user_id', suggestionBoxctrl]);

    function suggestionBoxctrl(common, datacontext, $scope, $modalInstance, user_id) {
        var getLogFn = common.logger.getLogFn;
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        console.log("user_id:"+user_id);
        var vm = this;
        $scope.ok = function (data) {
          vm.query = {
            user_id: user_id,
            subject: data.subject,
            message: data.message
          };
          return datacontext.suggestion_box(vm.query).then(function (httpResult) {
              // set new data
              log_success("Message sent. Thank you!");
              vm.results = httpResult.data.data;

              $modalInstance.close();
              return httpResult.data.data;
          });


        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();
